import * as React from "react";
import type { SVGProps } from "react";
const SvgVifLogoMark = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1011.06 673.36"
    {...props}
  >
    <path
      fill="#4abfad"
      d="m175.06 0 111.6 270.16L433.13 0l69.89 213.95-224.86 459.41L0 0h175.06z"
    />
    <path
      fill="#f5b52a"
      d="M466.81 0h156.92l-94.76 190.25L466.81 0zM528.97 233.77v439.59H313.01l215.96-439.59z"
    />
    <path
      fill="#f04e26"
      d="M560.76 197.15v476.21h171.36v-202.9h84.6l68.04-164.73H732.12V195.24H930.4L1011.06 0H659.8l-99.04 197.15z"
    />
  </svg>
);
export default SvgVifLogoMark;
